import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Inbox.css';
import Inbox from '../../components_new/Inbox/Inbox';
import { connect } from 'react-redux';
import { observer, inject } from 'mobx-react';

// Graphql
// import AllThreadsQuery from './AllThreadsQuery.graphql';
@inject('inboxStore')
@observer
class InboxContainer extends React.Component {
  componentDidMount() {
    this.props.inboxStore.updateSummary();
  }
  render() {
    return (
      <div className="f-1 f-start-stretch">
        <Inbox inboxStore={this.props.inboxStore} />
      </div>
    );
  }
}

export default compose(withStyles(s))(InboxContainer);

const res = {
  data: {
    pending: [
      {
        threadId: 328,
        reservationId: 536,
        listId: 9,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '4c8b24b0-42b2-11e9-a291-0b95d875ae1c',
        updatedAt: '2019-04-02T19:41:13.000Z',
        checkIn: '2019-05-22T00:00:00.000Z',
        checkOut: '2019-05-22T00:00:00.000Z',
        reservationState: 'pending',
        title: 'Bearcat',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: '33c2e64129058132060beb5d4154287f.jpeg',
        isRead: true,
        timezone: 'America/Denver',
        pickupTime: null,
        returnTime: null,
        pickupDay: null,
        returnDay: null,
        ownerPickupTime: null,
        ownerDropoffTime: null,
        guestPickupTime: null,
        guestDropoffTime: null,
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jeremy',
        guestLastName: 'Robertson',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: '9b039e485d4c99ad5a0216662ba45be4.png',
        isHost: true,
        otherDisplayName: 'Jeremy R',
        otherFirstName: 'Jeremy',
        otherPicture: '9b039e485d4c99ad5a0216662ba45be4.png',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'pending',
        pickupDate: '2019-05-22T00:00:00.000Z',
        returnDate: '2019-05-22T00:00:00.000Z',
        timespan: 'May 21',
      },
    ],
    approved: [],
    completed: [
      {
        threadId: 240,
        reservationId: 460,
        listId: 9,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '5a25bc10-450b-11e9-8f77-f51fe6b57017',
        updatedAt: '2019-03-27T20:06:44.000Z',
        checkIn: '2019-03-18T00:00:00.000Z',
        checkOut: '2019-03-18T00:00:00.000Z',
        reservationState: 'expired',
        title: 'Bearcat',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: '33c2e64129058132060beb5d4154287f.jpeg',
        isRead: true,
        timezone: 'America/Denver',
        pickupTime: null,
        returnTime: null,
        pickupDay: null,
        returnDay: null,
        ownerPickupTime: null,
        ownerDropoffTime: null,
        guestPickupTime: null,
        guestDropoffTime: null,
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jason',
        guestLastName: 'Fairbourne',
        hostBannedId: null,
        guestBannedId: 1,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: '281bf63d2e0ef92484ed268b6e736648.jpeg',
        isHost: true,
        otherDisplayName: 'Jason F',
        otherFirstName: 'Jason',
        otherPicture: null,
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'completed',
        timespan: 'Mar 17',
      },
      {
        threadId: 284,
        reservationId: 493,
        listId: 9,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '4c8b24b0-42b2-11e9-a291-0b95d875ae1c',
        updatedAt: '2019-03-28T04:00:00.000Z',
        checkIn: '2019-04-08T00:00:00.000Z',
        checkOut: '2019-04-08T00:00:00.000Z',
        reservationState: 'expired',
        title: 'Bearcat',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: '33c2e64129058132060beb5d4154287f.jpeg',
        isRead: true,
        timezone: 'America/Denver',
        pickupTime: null,
        returnTime: null,
        pickupDay: null,
        returnDay: null,
        ownerPickupTime: null,
        ownerDropoffTime: null,
        guestPickupTime: null,
        guestDropoffTime: null,
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jeremy',
        guestLastName: 'Robertson',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: '9b039e485d4c99ad5a0216662ba45be4.png',
        isHost: true,
        otherDisplayName: 'Jeremy R',
        otherFirstName: 'Jeremy',
        otherPicture: '9b039e485d4c99ad5a0216662ba45be4.png',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'completed',
        timespan: 'Apr 7',
      },
    ],
    exchanges: [
      {
        threadId: 158,
        reservationId: 387,
        listId: 312,
        hostId: 'e102e330-200c-11e9-98e0-713860d3fa2b',
        guestId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        updatedAt: '2019-03-11T19:22:02.000Z',
        checkIn: '2019-03-11T00:00:00.000Z',
        checkOut: '2019-03-11T00:00:00.000Z',
        reservationState: 'approved',
        title: 'Trampoline',
        city: 'Springville',
        state: 'Utah',
        coverPhotoName: 'd9f7e24df222b0689538e41375dc4a85.jpeg',
        isRead: true,
        timezone: 'America/Denver',
        pickupTime: '00:00:00',
        returnTime: '00:00:00',
        pickupDay: '2019-03-11T00:00:00.000Z',
        returnDay: '2019-03-11T00:00:00.000Z',
        ownerPickupTime: '2019-03-11T20:28:21.000Z',
        ownerDropoffTime: '2019-03-22T18:10:19.000Z',
        guestPickupTime: '2019-03-11T20:48:26.000Z',
        guestDropoffTime: '2019-03-18T17:39:15.000Z',
        hostFirstName: 'Chance',
        hostLastName: 'Farr',
        guestFirstName: 'Jeremy',
        guestLastName: 'Robertson',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: '281bf63d2e0ef92484ed268b6e736648.jpeg',
        guestPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        isHost: false,
        otherDisplayName: 'Chance F',
        otherFirstName: 'Chance',
        otherPicture: '281bf63d2e0ef92484ed268b6e736648.jpeg',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'exchanges',
        pickupCompleted: true,
        returnCompleted: true,
        pickupDate: '2019-03-10T07:00:00.000Z',
        returnDate: '2019-03-10T07:00:00.000Z',
        isExchange: true,
        timespan: 'past',
      },
      {
        threadId: 123,
        reservationId: 173,
        listId: 9,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '5f3602a0-296d-11e9-986c-893e86ca52f8',
        updatedAt: '2019-03-04T22:29:38.000Z',
        checkIn: '2019-03-04T00:00:00.000Z',
        checkOut: '2019-03-04T00:00:00.000Z',
        reservationState: 'approved',
        title: 'Bearcat',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: '33c2e64129058132060beb5d4154287f.jpeg',
        isRead: true,
        timezone: 'America/Denver',
        pickupTime: '16:00:00',
        returnTime: '09:00:00',
        pickupDay: '2019-03-03T00:00:00.000Z',
        returnDay: '2019-03-05T00:00:00.000Z',
        ownerPickupTime: '2019-03-04T23:25:39.000Z',
        ownerDropoffTime: '2019-03-04T23:27:14.000Z',
        guestPickupTime: '2019-03-04T23:26:18.000Z',
        guestDropoffTime: '2019-03-04T23:27:19.000Z',
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jason',
        guestLastName: 'Fairbourne',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: 'bc18d6a9833cbf9222e2b9e429a11a2f.jpeg',
        isHost: true,
        otherDisplayName: 'Jason F',
        otherFirstName: 'Jason',
        otherPicture: 'bc18d6a9833cbf9222e2b9e429a11a2f.jpeg',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'exchanges',
        pickupCompleted: true,
        returnCompleted: true,
        pickupDate: '2019-03-02T23:00:00.000Z',
        returnDate: '2019-03-04T16:00:00.000Z',
        isExchange: true,
        timespan: 'past',
      },
      {
        threadId: 120,
        reservationId: 168,
        listId: 527,
        hostId: 'a70b4bb0-21ea-11e9-9efc-f74e4918c7ef',
        guestId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        updatedAt: '2019-03-04T06:18:47.000Z',
        checkIn: '2019-03-03T00:00:00.000Z',
        checkOut: '2019-03-03T00:00:00.000Z',
        reservationState: 'approved',
        title: 'Fish Tape',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: 'b11831d1d01925e01e45f74255edea72.jpeg',
        isRead: true,
        timezone: 'America/Denver',
        pickupTime: '23:11:00',
        returnTime: '23:11:00',
        pickupDay: '2019-03-03T00:00:00.000Z',
        returnDay: '2019-03-03T00:00:00.000Z',
        ownerPickupTime: '2019-03-18T03:35:07.000Z',
        ownerDropoffTime: null,
        guestPickupTime: '2019-03-18T03:42:58.000Z',
        guestDropoffTime: null,
        hostFirstName: 'AJ',
        hostLastName: 'Larson',
        guestFirstName: 'Jeremy',
        guestLastName: 'Robertson',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: '1be79ccba1ba2a8f495a51c441a47782.jpeg',
        guestPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        isHost: false,
        otherDisplayName: 'AJ L',
        otherFirstName: 'AJ',
        otherPicture: '1be79ccba1ba2a8f495a51c441a47782.jpeg',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'exchanges',
        pickupCompleted: true,
        returnCompleted: null,
        pickupDate: '2019-03-03T06:11:00.000Z',
        returnDate: '2019-03-03T06:11:00.000Z',
        isExchange: true,
        timespan: 'past',
      },
    ],
    inquiries: [
      {
        threadId: 259,
        reservationId: null,
        listId: 84,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '5a25bc10-450b-11e9-8f77-f51fe6b57017',
        updatedAt: '2019-04-02T16:45:19.000Z',
        checkIn: null,
        checkOut: null,
        reservationState: null,
        title: 'The Wonderbaut',
        city: 'Bountiful',
        state: 'UT',
        coverPhotoName: '0e19bded7bf528742ce7e727a78690ea.jpeg',
        isRead: true,
        timezone: null,
        pickupTime: null,
        returnTime: null,
        pickupDay: null,
        returnDay: null,
        ownerPickupTime: null,
        ownerDropoffTime: null,
        guestPickupTime: null,
        guestDropoffTime: null,
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jason',
        guestLastName: 'Fairbourne',
        hostBannedId: null,
        guestBannedId: 1,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: '281bf63d2e0ef92484ed268b6e736648.jpeg',
        isHost: true,
        otherDisplayName: 'Jason F',
        otherFirstName: 'Jason',
        otherPicture: null,
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'inquiry',
      },
      {
        threadId: 286,
        reservationId: null,
        listId: 9,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '4d63be80-2573-11e9-98bb-2f2bd39e1319',
        updatedAt: '2019-04-02T17:43:12.000Z',
        checkIn: null,
        checkOut: null,
        reservationState: null,
        title: 'Bearcat',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: '33c2e64129058132060beb5d4154287f.jpeg',
        isRead: true,
        timezone: null,
        pickupTime: null,
        returnTime: null,
        pickupDay: null,
        returnDay: null,
        ownerPickupTime: null,
        ownerDropoffTime: null,
        guestPickupTime: null,
        guestDropoffTime: null,
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jeremy',
        guestLastName: 'Robertson',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: '64c2e0e4d5da9466d2a49f2c71c8b942.png',
        isHost: true,
        otherDisplayName: 'Jeremy R',
        otherFirstName: 'Jeremy',
        otherPicture: '64c2e0e4d5da9466d2a49f2c71c8b942.png',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'inquiry',
      },
      {
        threadId: 287,
        reservationId: null,
        listId: 9,
        hostId: 'ff1c8050-1ff4-11e9-98e0-713860d3fa2b',
        guestId: '4d63be80-2573-11e9-98bb-2f2bd39e1319',
        updatedAt: '2019-03-27T14:15:45.000Z',
        checkIn: null,
        checkOut: null,
        reservationState: null,
        title: 'Bearcat',
        city: 'Lehi',
        state: 'UT',
        coverPhotoName: '33c2e64129058132060beb5d4154287f.jpeg',
        isRead: true,
        timezone: null,
        pickupTime: null,
        returnTime: null,
        pickupDay: null,
        returnDay: null,
        ownerPickupTime: null,
        ownerDropoffTime: null,
        guestPickupTime: null,
        guestDropoffTime: null,
        hostFirstName: 'Jeremy',
        hostLastName: 'Robertson',
        guestFirstName: 'Jeremy',
        guestLastName: 'Robertson',
        hostBannedId: null,
        guestBannedId: null,
        hostPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        guestPicture: '64c2e0e4d5da9466d2a49f2c71c8b942.png',
        isHost: true,
        otherDisplayName: 'Jeremy R',
        otherFirstName: 'Jeremy',
        otherPicture: '64c2e0e4d5da9466d2a49f2c71c8b942.png',
        myPicture: 'b99a276b1999179f4ee4b90ada58334f.png',
        group: 'inquiry',
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/routes/inbox/InboxContainer.js